import { 
    LOOK_OUT_FOR_THE_LITTLE_GUYS_T_SHIRT, 
    TURTLE_CROSSING_PIN,
    SOCKS,  
    Product
} from '../products';

const slowAndSteadyRecos: Product[] = [
    LOOK_OUT_FOR_THE_LITTLE_GUYS_T_SHIRT,
    TURTLE_CROSSING_PIN,
    SOCKS,   
];

export default slowAndSteadyRecos;